import fetchLogger from "./fetchLogger";

/** PATCH /api/v1/issues/:id/extend — adds 30 days to expiresAt */
export default async function extendIssue(id) {
  const result = { return: 0, msg: "Failed extending issue", data: null };

  const res = await fetchLogger({
    method: "PATCH",
    url: `/api/v1/issues/${id}/extend`,
  });

  if (res.ok) {
    result.return = 1;
    result.msg = "Retention extended by 30 days";
    result.data = res.data?.data || null;
  } else {
    const message = res.data?.message;
    result.msg = Array.isArray(message) ? message.join(", ") : message || result.msg;
  }

  return result;
}
